import { Stack, createIcon } from '@chakra-ui/react';
import { useLocation, useNavigate } from 'react-router-dom';

import AiAgentAdminNavigationItem from './AiAgentAdminNavigationItem';
import { useTranslation } from 'react-i18next';

const AiAgentDashboardIcon = createIcon({
  displayName: 'AiAgentDashboardIcon',
  viewBox: '0 0 14 14',
  path: [
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.21094 7.87053L1.53991 7.87051C1.96117 7.87048 2.35154 7.64944 2.56828 7.2882L2.62047 7.20121C3.127 6.357 4.38101 6.45748 4.74665 7.37158C5.16782 8.42452 6.68319 8.34805 6.99622 7.25805L7.5537 5.31687C7.86595 4.22962 9.3717 4.13941 9.81151 5.18161L10.6368 7.13739C10.8243 7.58167 11.2597 7.87046 11.7419 7.87046H12.1892"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeMiterlimit="10"
      />
      <path
        d="M6.66504 12.6641C9.97875 12.6641 12.665 9.97777 12.665 6.66406C12.665 3.35035 9.97875 0.664062 6.66504 0.664062C3.35133 0.664062 0.665039 3.35035 0.665039 6.66406C0.665039 9.97777 3.35133 12.6641 6.66504 12.6641Z"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>,
  ],
});

const ExpertsOverviewIcon = createIcon({
  displayName: 'ExpertsOverviewIcon',
  viewBox: '0 0 15 12',
  path: [
    <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.10449 0C12.142 0 14.6044 2.47903 14.6045 5.53711C14.6045 8.5953 12.1421 11.0742 9.10449 11.0742C6.06693 11.0742 3.60449 8.5953 3.60449 5.53711C3.60462 2.47903 6.067 0 9.10449 0ZM13.4531 5.5127C12.7032 5.26923 12.1265 5.3033 11.6738 5.46777C11.1532 5.65709 10.7199 6.04614 10.3545 6.55957C9.12289 8.28929 7.2551 8.73864 5.72949 8.30469C6.52822 9.29417 7.74524 9.9248 9.10449 9.9248C11.4996 9.9248 13.4541 7.96752 13.4541 5.53711C13.4541 5.52896 13.4532 5.52083 13.4531 5.5127ZM9.10449 1.15039C6.70946 1.15039 4.75501 3.10681 4.75488 5.53711C4.75488 5.86468 4.7911 6.18349 4.8584 6.49023C5.86484 7.5787 8.07815 7.7744 9.41797 5.89258C9.8669 5.26188 10.4702 4.68149 11.2812 4.38672C11.8721 4.17206 12.5346 4.12325 13.2705 4.27539C12.7323 2.46409 11.0668 1.15039 9.10449 1.15039Z"
        fill="currentColor"
      />
      <path
        d="M5.5 0C5.75316 0 5.82236 0.331311 5.61522 0.476847C5.35308 0.661011 5.10589 0.864974 4.87596 1.08676C4.78962 1.17004 4.68128 1.22687 4.56416 1.25279C2.61609 1.68396 1.1505 3.43264 1.15039 5.53711C1.15039 7.643 2.61813 9.39174 4.56811 9.82159C4.68521 9.8474 4.79354 9.90413 4.87988 9.98733C5.1089 10.2081 5.35486 10.4112 5.61566 10.5947C5.8235 10.741 5.75412 11.0742 5.5 11.0742C2.46243 11.0742 0 8.5953 0 5.53711C0.000126698 2.47903 2.46251 0 5.5 0Z"
        fill="currentColor"
      />
    </svg>,
  ],
});

export default function AiAgentAdminNavigation() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;

  const navItems = [
    {
      label: t('aiAgent.experts.nav.dashboard'),
      onClick: () => navigate('/admin/eddy'),
      isActive: pathname === '/admin/eddy',
      icon: <AiAgentDashboardIcon />,
    },
    {
      label: t('aiAgent.experts.nav.overview'),
      onClick: () => navigate('/admin/eddy/experts'),
      isActive:
        pathname.includes('/admin/eddy/experts') ||
        pathname.includes('/admin/eddy/experts/details'),
      icon: <ExpertsOverviewIcon />,
    },
  ];

  return (
    <Stack spacing={2} paddingX={2}>
      {navItems.map((item) => (
        <AiAgentAdminNavigationItem
          key={item.label}
          label={item.label}
          icon={item.icon}
          onClick={item.onClick}
          isActive={item.isActive}
        />
      ))}
    </Stack>
  );
}
